import {
  IQuestionDefinition,
  IQuestionProperty,
  TPropertyDepWindowFunctions,
} from '../constants/queryCreation.interface';

/**
 * iterate the concept's properties to get all of the properties that have window functions
 * @param properties
 * @returns all of the concept's properties that have window functions
 */
const getPropertiesWithWfs = (properties: IQuestionProperty[] = []): IQuestionProperty[] => {
  return properties?.reduce((propAcc: IQuestionProperty[], prop) => {
    if (prop.windowFunctions.length > 0) {
      return [...propAcc, prop];
    }

    return propAcc;
  }, []);
};

/**
 * Iterates the question definition to return an array of all of the window functions used in the question
 * @param definition
 * @returns IWindowFunctionItem[]
 */
export const getAllPropertyWfs = (
  definition: IQuestionDefinition
): TPropertyDepWindowFunctions[] => {
  const wfsInDef = Object.keys(definition || {}).reduce(
    (acc: TPropertyDepWindowFunctions[], concept: string) => {
      // SubQuery props will be handled in the future in issue #3919 https://github.com/kobai-io/blossom-Client/issues/3919
      const isSubQuery = definition?.[concept]?.subQueryId !== null;
      if (isSubQuery) return acc;

      let propertiesWithWFs = getPropertiesWithWfs(
        (definition?.[concept] || { properties: [] }).properties
      );

      if (propertiesWithWFs.length > 0) {
        return [
          ...acc,
          {
            concept,
            conceptName: definition?.[concept].label,
            properties: propertiesWithWFs,
          },
        ];
      }

      return acc;
    },
    []
  );

  return wfsInDef;
};
